import {Component, EventEmitter, HostBinding, Input, OnInit, Output} from '@angular/core';
import {FormBuilder} from '@angular/forms';
import {Router} from '@angular/router';
import {FeatureTypeService} from '@catcore/services';
import {Feature} from '@catcore/services/feature/feature';
import {GenericLinkedResource} from '@catcore/types/base';
import {GenericResourceApiService} from '@catfeatures/services/generic-resource-api.service';
import {navigateToFeatureResource} from '@catfeatures/shared/utils';
import {NotificationsService} from '@catmodules/core/services/index';
import {FeatureUnitsService} from '@catmodules/models/feature-units/services/feature-units.service';
import {FeatureUnit} from '@catmodules/models/feature-units/types';
import {LinkItem} from '@catui/types';

const componentBaseName = 'feature-parameter-landing';
const selectorName = 'cat-' + componentBaseName;
const defaultClassNames = [selectorName].join(' ');

/**
 * Component to display all available parameters for a FeatureUnit
 * The required FeatureUnit will be expected as the parent resource reference
 *
 */
@Component({
  selector: 'cat-feature-parameter-wizard-form',
  templateUrl: './feature-parameter-landing.component.html',
})
export class FeatureParameterLandingComponent implements OnInit {
  @HostBinding('class') classNames = defaultClassNames;

  @Output() onFormSubmit = new EventEmitter();
  @Input() resourceId: string;
  @Input() parentResourceId: string;

  @Input() schema;

  linkedParametersList: LinkItem[] = [];

  private feature: Feature;
  private featureUnit: FeatureUnit;

  constructor(private formBuilder: FormBuilder,
              private notificationService: NotificationsService,
              private router: Router,
              private featureService: FeatureTypeService,
              private featureUnitsService: FeatureUnitsService,
              private resourceApiService: GenericResourceApiService) {
  }

  ngOnInit() {
    this.featureService
      .getCurrent()
      .subscribe((feature: Feature) => this.feature = feature);
    this
      .resourceApiService
      .resolveForId(this.parentResourceId)
      .subscribe((featureUnit: FeatureUnit) => {
        this.featureUnit = featureUnit;
        this.updateLinkedItems(featureUnit);
      });

  }

  private updateLinkedItems(featureUnit: FeatureUnit) {
    const links: LinkItem[] = [];
    this.featureUnitsService
      .extractParametersFor(featureUnit)
      .forEach((item: GenericLinkedResource) => {
        links.push({label: item.label, navigate: (router: Router) => navigateToFeatureResource(router, this.feature, item), raw: item});
      });
    this.linkedParametersList = links;
  }
}



// WEBPACK FOOTER //
// /agent/workspace/CUS-LHT_NICE_nto_nto_CAT_develop@2/app/Resources/Public/src/app/modules/models/feature-parameter/components/feature-parameter-landing/feature-parameter-landing.component.ts